import React from 'react'
import Loader from '../../loaders'
import { strings } from '../../../localization/strings'
import { Typography, Button } from '@material-ui/core/index'
import AppIcon from '@material-ui/icons/GetApp'
import ManualIcon from '@material-ui/icons/LibraryBooks'
import { RESOURCES_URL } from '../../../server/connection'
import {
    blobToDownloadedFile,
    downloadFile,
} from '../../../helpers/restHelpers'
import logotipoPudo from '../../../assets/icons/logo-pudo-en-tu-camino.png'

const getResourceUrl = (key) => RESOURCES_URL + 'Resource/get?key=' + key
const wooCommercePluginUrl = getResourceUrl('WooCommercePlugin')
const wooCommerceManualUrl = getResourceUrl('WooCommerceManual')

class Component extends React.Component {
    state = {
        loader: false,
    }

    componentDidMount() {}

    downloadPlugin = () => {
        this.setState({ loader: true })
        downloadFile(wooCommercePluginUrl)
            .then((blob) => {
                this.setState({ loader: false })
                blobToDownloadedFile(blob, 'WooCommercePlugIn.zip')
            })
            .catch((error) => {
                this.setState({ loader: false })
                window.showDialog({ message: strings.exceptions.NetworkError })
            })
    }

    render() {
        if (this.state.loader) return <Loader />

        return (
            <div
                style={{
                    maxWidth: 350,
                    margin: 'auto',
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <img src={logotipoPudo} style={{width:'200px', margin:'30px auto 0'}} onClick={() => this.props.history.push('/')} />
                <div style={{ paddingTop: 50 }} />

                <Typography
                    variant="h6"
                    color="textPrimary"
                    style={{ flexGrow: 1 }}
                >
                    {strings.wooCommerceGetManual}
                </Typography>

                <Button
                    color="primary"
                    target="_blank"
                    href={wooCommerceManualUrl}
                >
                    <ManualIcon color="primary" style={{ fontSize: 64 }} />
                </Button>

                <div style={{ paddingTop: 50 }} />

                <Typography
                    variant="h6"
                    color="textPrimary"
                    style={{ flexGrow: 1 }}
                >
                    {strings.wooCommerceGetApp}
                </Typography>

                <Button color="primary" onClick={this.downloadPlugin}>
                    <AppIcon color="primary" style={{ fontSize: 64 }} />
                </Button>
            </div>
        )
    }
}

export default Component
